import { normalizeEvent } from '../events/normalizers';

export const fromQuery = normalizeEvent;



// WEBPACK FOOTER //
// ./src/resources/search/normalizers.js